import {
  INIT_PAGINATOR,
  SET_PAGE,
  LOAD_PAGINATED_PAGE,
} from './constants'

export function initialize (options) {
  return {
    type: INIT_PAGINATOR,
    payload: options,
  }
}

export function loadPage (name) {
  return (dispatch, getState) => {
    const state = getState().paginator[name]
    if (state) {
      const { loadPage: cb, limit, offset } = state
      return dispatch({
        type: LOAD_PAGINATED_PAGE,
        payload: cb({ limit, offset }),
        meta: { name },
      })
    }
  }
}

export function setPage (name, n) {
  return {
    type: SET_PAGE,
    payload: n,
    meta: { name },
  }
}

export function gotoPage (name, n) {
  return (dispatch, getState) => {
    const state = getState().paginator[name]
    if (state) {
      const { current, pages } = state
      if (current !== n && n >= 1 && n <= pages) {
        dispatch(setPage(name, n))
        dispatch(loadPage(name))
      }
    }
  }
}

export function nextPage (name) {
  return (dispatch, getState) => {
    const state = getState().paginator[name]
    const last = state.pages === state.current
    if (!last) {
      dispatch(setPage(name, state.current + 1))
      dispatch(loadPage(name))
    }
  }
}

export function prevPage (name) {
  return (dispatch, getState) => {
    const state = getState().paginator[name]
    const first = state.current === 1
    if (!first) {
      dispatch(setPage(name, state.current - 1))
      dispatch(loadPage(name))
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/paginator/actions.js